import Lenis from "lenis";
import "./App.css";
import { Suspense, useEffect } from "react";

import RouterComponent from "./Utils/RouterComponent";
import { BrowserRouter } from "react-router-dom";

function App() {
  useEffect(() => {
    const lensis = new Lenis();
    function raf(time) {
      lensis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }, []);
  return (
    <>
      <Suspense fallback={<h1>Loading</h1>}>
        <BrowserRouter>
          <RouterComponent />
        </BrowserRouter>
      </Suspense>
    </>
  );
}

export default App;
